module.exports = __webpack_public_path__ + "03_long_gray.219a82e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/03_long_gray.png
// module id = 9QZ7
// module chunks = 0